export enum DashboardChartWidgetBlock {
  Root = 'DashboardChartWidget',
}
